
    var riot = require('riot')
    //src: starling/src/tags/link-menu.html
riot.tag2('link-menu',
  '<ul ref="menuList" class="floating-menu_list"> <li if="{link}" class="floating-menu_item floating-menu_item--iconless" onmouseenter="{delayedHideSubMenus}"> <span class="floating-menu_label">Direction</span> <span ref="dir" class="arrow-container container-right"> <div class="arrow r-left {getArrowButtonStyle(\'left\').class}" onclick="{changeRDirection.bind(null, \'left\')}" ondblclick="{changeRDirection.bind(null, \'left\')}"> <i class="arrow fa fa-arrow-left" riot-style="{getArrowButtonStyle(\'left\').style}"></i> </div> <div class="arrow r-right {getArrowButtonStyle(\'right\').class}" onclick="{changeRDirection.bind(null, \'right\')}" ondblclick="{changeRDirection.bind(null, \'right\')}"> <i class="arrow fa fa-arrow-right" riot-style="{getArrowButtonStyle(\'right\').style}"></i> </div> </span> </li> <li class="floating-menu_item" onmouseenter="{openColorPicker}"> <svg class="floating-menu_icon"> <path d="M 0 8 L 40 8" stroke="{getLinePreviewColor(link)}" stroke-dasharray="{getLinePreviewStyle()}" stroke-width="{getLinePreviewWidth()}"></path> </svg> <span class="floating-menu_label">Style</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <color-picker if="{colorPickerVisible}" positioning="{computeColorPickerPositionStyle()}" colors="{colorProgression}" setcolor="{setColor}" setlinetype="{setLineType}" setlinewidth="{setLineWidth}" linkid="{link.id}" type="link"></color-picker> </li> <li if="{link}" class="floating-menu_item" onmouseenter="{openCurvaturePicker}"> <svg class="floating-menu_icon"> <use xlink:href="#line-{link.lineCurvature}-icon"></use> </svg> <span class="floating-menu_label">Type</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <menu-item-link-curvature></menu-item-link-curvature> </li> <li hide="{link && link.linkNodeId}" class="floating-menu_item" onclick="{addCard}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#title-icon"></use> </svg> <span class="floating-menu_label">Label line</span> </li> <li if="{link && link.linkNodeId}" class="floating-menu_item--divider"></li> <li class="floating-menu_item" onclick="{straightenLine}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#straighten-line-icon"></use> </svg> <span class="floating-menu_label">Straighten line</span> </li> <li if="{pui.getPerspectives().length}" class="floating-menu_item--divider"></li> <li if="{pui.getPerspectives().length}" ref="perspectiveItem" class="floating-menu_item" onmouseenter="{summonPerspectivesPanel}"> <i class="floating-menu_icon material-icons">visibility</i> <span class="floating-menu_label">Perspectives</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </li> <li class="floating-menu_item--divider"></li> <li class="floating-menu_item" onclick="{deleteLink}" onmouseenter="{delayedHideSubMenus}"> <i class="floating-menu_icon material-icons">delete</i> <span class="floating-menu_label">Delete line</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _geom = require('lib/geom.js');

var _constants = require('lib/constants');

var _constants2 = require('lib/constants.js');

var _perspectivesUi = require('lib/perspectives-ui');

var _menuUi = require('lib/menu-ui');

var _relationshipUi = require('lib/relationship-ui');

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.pui = _perspectivesUi.pui;
this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.canvas = this.opts.canvas;
this.canvas.linkMenuTag = this;
this.store = _store_instance2.default;
this.colorProgression = _constants2.LINK_COLORS;
this.colorPickerVisible = false;
this.menuName = 'link-menu';

this.on('mount', function () {
  _this.canvas.linkMenuTag = _this;
  $(_this.refs.menuList).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.summon = function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      link = _ref.link,
      tag = _ref.tag;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  _this.canvas.hidePopups();
  _this.canvas.rightClickMenu.hide();
  _this.x = x;
  _this.y = y;
  _this.sx = (x - tx) / scale;
  _this.sy = (y - ty) / scale;
  _this.summoned = true;
  _this.link = link;
  _this.tag = tag;
  _this.root.classList.remove('floating-menu--hidden');
  _this.update();

  _this.positionSelf({
    selfEl: _this.refs.menuList,
    clickPosition: { x: _this.x, y: _this.y }
  });
};

this.hide = function () {
  _this.summoned = false;
  _this.link = null;
  _this.colorPickerVisible = false;
  _this.closeCurvaturePicker();
  _this.root.classList.add('floating-menu--hidden');
  _this.canvas.nodePerspectivesPanelTag.clearInput();
};

this.deleteLink = function (e) {
  e.stopPropagation();
  e.preventDefault();
  _this.canvas.deleteLink(_this.link.id);
  _this.canvas.hidePopups();
  _this.hide();
};

this.addCard = function (e) {
  e.stopPropagation();
  e.preventDefault();
  if (_this.link.linkNode()) return;
  _relationshipUi.rui.addCardsToLinks([_this.link.id]);
  _this.hide();
};

this.getArrowButtonStyle = function (direction) {
  var link = _this.link;
  if (!link) {
    return { style: '', class: '' };
  }
  var fromNode = _this.store.getNode(link.fromNodeId);
  var toNode = _this.store.getNode(link.toNodeId);
  var thirdPoint = link.getThirdPoint();

  var _findCircleFromPoints = (0, _geom.findCircleFromPoints)(thirdPoint, fromNode.absolutePosition, toNode.absolutePosition),
      centerPoint = _findCircleFromPoints[0],
      radius = _findCircleFromPoints[1];

  var angle = void 0;
  if (radius < 10000) {
    angle = (0, _geom.computeSlope)(centerPoint, { x: _this.sx, y: _this.sy }) + Math.PI / 2;
    if (_this.canvas.linkTags[link.id].sweepFlag === 0) angle += Math.PI;
  } else {
    angle = (0, _geom.computeSlope)(fromNode.absolutePosition, toNode.absolutePosition);
  }

  angle = (0, _geom.normalizeAngle)(angle);

  // ensure directions are never backwards
  if (direction === 'right') {
    if (angle > Math.PI / 2 && angle < 3 * Math.PI / 2) {
      _this.refs.dir.classList.add('backwards');
    } else {
      _this.refs.dir.classList.remove('backwards');
    }
  }

  //TODO make this work to ensure directions are never backwards
  var colorClass = link.direction === direction || link.direction === 'both' ? 'selected' : '';

  return {
    style: 'transform: rotate(' + angle + 'rad);',
    class: colorClass
  };
};

this.changeRDirection = function (direction) {
  var event = window.event;
  if (event) {
    event.stopPropagation();
  }

  var link = _this.link;
  if (link.direction === 'right') {
    if (direction === 'right') {
      _this.setRDirection(link, 'none');
    } else if (direction === 'left') {
      _this.setRDirection(link, 'both');
    }
  } else if (link.direction === 'left') {
    if (direction === 'right') {
      _this.setRDirection(link, 'both');
    } else if (direction === 'left') {
      _this.setRDirection(link, 'none');
    }
  } else if (link.direction === 'both') {
    if (direction === 'right') {
      _this.setRDirection(link, 'left');
    } else if (direction === 'left') {
      _this.setRDirection(link, 'right');
    }
  } else if (link.direction === 'none') {
    if (direction === 'right') {
      _this.setRDirection(link, 'right');
    } else if (direction === 'left') {
      _this.setRDirection(link, 'left');
    }
  }
  if (_this.canvas.linkTags[link.id]) {
    _this.canvas.linkTags[link.id].updateDirectionState();
  }
  _this.update();
};

this.setRDirection = function (link, direction) {
  var prevDirection = link.direction;
  link.direction = direction;
  _this.canvas.operation.setLinkDirection({
    linkUUID: link.id,
    direction: direction,
    prevDirection: prevDirection,
    onFailure: function onFailure(err) {
      console.log('setLinkDirection failure: ' + err);
    }
  });
};

this.setColor = function (color) {
  if (_this.canvas.linkTags[_this.link.id]) {
    var prevColor = _this.link.color;
    var newColor = _constants2.LINK_COLORS_MAPPING[color] || _constants.DEFAULTS.LINK_COLOR;
    _this.link.setColor(newColor);
    _this.canvas.linkTags[_this.link.id].updateStrokeColor();
    if (_this.link.linkNode()) {
      _this.canvas.nodeTags[_this.link.linkNode().id].update({ forceUpdate: true });
    }
    _this.canvas.operation.setLinkColor({
      linkUUID: _this.link.id,
      prevColor: prevColor,
      color: newColor,
      onFailure: function onFailure(err) {
        console.log('setLinkColor failure: ' + err);
      }
    });
  }
  _this.update();
};

this.setLineWidth = function (width) {
  if (_this.canvas.linkTags[_this.link.id]) {
    var prevWidth = _this.link.lineWidth;
    var newWidth = width;
    _this.link.setLinkWidth(newWidth);
    _this.canvas.linkTags[_this.link.id].updateStyle();
    if (_this.link.linkNode()) {
      _this.canvas.nodeTags[_this.link.linkNode().id].update({ forceUpdate: true });
    }
    _this.canvas.operation.setLinkWidth({
      linkUUID: _this.link.id,
      lineWidth: newWidth,
      prevWidth: prevWidth,
      onFailure: function onFailure(err) {
        console.log('setLinkType failure: ' + err);
      }
    });
  }
  _this.update();
};

this.setLineType = function (type) {
  if (_this.canvas.linkTags[_this.link.id]) {
    var prevType = _this.link.lineType;
    var newType = type;
    _this.link.setLinkType(newType);
    _this.canvas.linkTags[_this.link.id].updateStyle();
    if (_this.link.linkNode()) {
      _this.canvas.nodeTags[_this.link.linkNode().id].update({ forceUpdate: true });
    }
    _this.canvas.operation.setLinkType({
      linkUUID: _this.link.id,
      lineType: newType,
      prevType: prevType,
      onFailure: function onFailure(err) {
        console.log('setLinkType failure: ' + err);
      }
    });
  }
  _this.update();
};

this.delayedHideSubMenus = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function () {
  _this.canvas.nodePerspectivesPanelTag.hide();
  _this.closeColorPicker();
  _this.closeCurvaturePicker();
};

this.openColorPicker = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'linkcolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      if (_this.colorPickerVisible) return;
      _this.hideSubMenus();
      _this.colorPickerVisible = true;
      _this.update();
    }
  });
};

this.openCurvaturePicker = function (e) {
  e.stopPropagation();

  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'linkcurvature',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      return _this.tags['menu-item-link-curvature'].show({
        links: [_this.link]
      });
    }
  });
};

this.getLinePreviewStyle = function () {
  if (!_this.link || !_this.link.lineType) {
    return '';
  }
  var dasharrayValues = {
    'dotted': '4px 4px',
    'dashed': '9px 3px',
    'solid': ''
  };
  return dasharrayValues[_this.link.lineType] || '';
};

this.getLinePreviewWidth = function () {
  if (!_this.link || !_this.link.lineWidth) {
    return _constants2.LINK_WIDTHS_MAPPING.s;
  }
  return _constants2.LINK_WIDTHS_MAPPING[_this.link.lineWidth] || _constants2.LINK_WIDTHS_MAPPING.s;
};

this.getLinePreviewColor = function (link) {
  if (link && link.color) {
    return _constants.COLOR_VAR_TO_HEX_MAPPING[link.color];
  } else {
    return _constants.COLOR_VAR_TO_HEX_MAPPING['$gray4'];
  }
};

this.closeColorPicker = function () {
  _this.colorPickerVisible = false;
  _this.update();
};

this.closeCurvaturePicker = function () {
  var tags = _this.tags;

  if (tags['menu-item-link-curvature']) {
    tags['menu-item-link-curvature'].hide();
  }
};

this.computeColorPickerPositionStyle = function () {
  var width = _this.refs.menuList.getBoundingClientRect().width;
  if (_this.positionSubToLeft) {
    return 'top:0px;right:' + width + 'px';
  } else {
    return 'top:0px;left:' + width + 'px';
  }
};

this.straightenLine = function () {
  if (!_this.tag) return;
  _this.tag.straightenLine();
  _this.hide();
};

this.summonPerspectivesPanel = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'perspectives',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this._summonPerspectivesPanel(e);
    }
  });
};
this._summonPerspectivesPanel = function (e) {
  _this.hideSubMenus(e);
  if (_this.positionSubToLeft) {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveItem,
      isBulkAction: false,
      positionToLeft: true,
      isLink: true
    });
  } else {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveItem,
      isBulkAction: false,
      positionToLeft: false,
      isLink: true
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('link-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/link-menu.html
// module id = 627
// module chunks = 0